export const GET_COMPANIES = [
    {
        "Id": 19,
        "Name": "Test Company"
    }
]

export const GET_USERS = [
    {
        "Id": "3",
        "Name": "Test User1",
        "Email": "test.user1@heirsholdings.com",
        "Role": "SuperAdmin",
        "IsSuperAdmin": true
    },
    {
        "Id": "952",
        "Name": "TEST USER2",
        "Email": "test.user2@heirsholdings.com",
        "Role": "BasicUser",
        "IsSuperAdmin": false
    },
    {
        "Id": "1266",
        "Name": "Test User3",
        "Email": "test.user3@heirsholdings.com",
        "Role": "BasicUser",
        "IsSuperAdmin": false
    },
    {
        "Id": "1321",
        "Name": "Test User3",
        "Email": "test.user3@heirsholdings.com",
        "Role": "BasicUser",
        "IsSuperAdmin": false
    },
    {
        "Id": "1509",
        "Name": "TEST USERA",
        "Email": "test.usera@heirsholdings.com",
        "Role": "SuperAdmin",
        "IsSuperAdmin": true
    },
    {
        "Id": "1510",
        "Name": "TEST USERB",
        "Email": "test.userb@heirsholdings.com",
        "Role": "BasicUser",
        "IsSuperAdmin": false
    }
]

export const GET_COMPANY_ROLES = [
    {
        "Id": 12,
        "Name": "Human Resources"
    },
    {
        "Id": 13,
        "Name": "Innovation"
    },
    {
        "Id": 14,
        "Name": "HR Head/Director"
    },
    {
        "Id": 15,
        "Name": "Audit/Compliance"
    },
    {
        "Id": 16,
        "Name": "Finance"
    },
    {
        "Id": 17,
        "Name": "CFO"
    },
    {
        "Id": 18,
        "Name": "Admin"
    },
    {
        "Id": 19,
        "Name": "CEO"
    },
    {
        "Id": 20,
        "Name": "COO"
    },
    {
        "Id": 21,
        "Name": "IT"
    },
    {
        "Id": 22,
        "Name": "Director of Resources"
    },
    {
        "Id": 23,
        "Name": "test"
    },
    {
        "Id": 24,
        "Name": "Dominos"
    },
    {
        "Id": 116,
        "Name": "Payroll Role"
    },
    {
        "Id": 147,
        "Name": "U"
    },
    {
        "Id": 206,
        "Name": "CONTACTDBROLE"
    },
    {
        "Id": 226,
        "Name": "Testing Role"
    },
    {
        "Id": 324,
        "Name": "CONTACTDB_NONADMIN"
    },
    {
        "Id": 339,
        "Name": "covi"
    },
    {
        "Id": 340,
        "Name": "COVID19"
    },
    {
        "Id": 363,
        "Name": "CONTACT_DB_ROLE_ADMIN"
    },
    {
        "Id": 364,
        "Name": "CONTACT_DB_ROLE_BASIC"
    },
    {
        "Id": 377,
        "Name": "Asset Management Admin"
    }
]

export const GET_VENDOR_TYPES = [
    {
        "Description": "It is the name your business is known by",
        "IncludeBusinessInformation": true,
        "IncludePassportInformation": true,
        "IncludeDirectorInformation": true,
        "IncludeExecutiveDirectorInformation": true,
        "Id": 1,
        "Name": "Business Name"
    },
    {
        "Description": "It is an incorporated under any form of incorporation which permits that Body to be a member of a limited company.",
        "IncludeBusinessInformation": true,
        "IncludePassportInformation": true,
        "IncludeDirectorInformation": true,
        "IncludeExecutiveDirectorInformation": true,
        "Id": 2,
        "Name": "Incorporated Bodies"
    },
    {
        "Description": "It is in charge of an activity, department, or organization.",
        "IncludeBusinessInformation": true,
        "IncludePassportInformation": true,
        "IncludeDirectorInformation": true,
        "IncludeExecutiveDirectorInformation": false,
        "Id": 3,
        "Name": "Directors and Onwers"
    },
    {
        "Description": "It is the machinery of government that is responsible for the oversight and administration of specific functions.",
        "IncludeBusinessInformation": true,
        "IncludePassportInformation": true,
        "IncludeDirectorInformation": true,
        "IncludeExecutiveDirectorInformation": true,
        "Id": 4,
        "Name": "Government Agencies"
    },
    {
        "Description": "It is an apprentice engaged to do a routine job",
        "IncludeBusinessInformation": false,
        "IncludePassportInformation": true,
        "IncludeDirectorInformation": false,
        "IncludeExecutiveDirectorInformation": false,
        "Id": 5,
        "Name": "Individual"
    }
]

export const GET_VENDORS = {
    "TotalCount": 28,
    "CurrentPage": 0,
    "ExpectedPageSize": 10,
    "Results": [{
        "Id": "2af29988-012e-4cca-af6c-b475fd65b40f",
        "ContactSurname": "Ugochukwu",
        "ContactFirstname": "Ajalla",
        "ContactEmailAddress": "ohmsflexnigltd@gmail.com",
        "ContactPhoneNumber": "+2348068440754",
        "VendorName": "stockworld",
        "VendorStatus": 0,
        "VendorStatusName": "Pending",
        "CategoryName": "Technology",
        "StatusReason": null,
        "InitiatingCompanyId": 19,
        "HasApprovalRoute": false,
        "VendorApprovals": [],
        "NextVendorApproval": null
    }, {
        "Id": "1eb5d2bc-aa0f-4f5f-9eaa-c18ff08aedb3",
        "ContactSurname": "Durotoye",
        "ContactFirstname": "Bamba",
        "ContactEmailAddress": "b.durotoye@sharklasers.com",
        "ContactPhoneNumber": "+2348077662602",
        "VendorName": "Labamba Technologies",
        "VendorStatus": 0,
        "VendorStatusName": "Pending",
        "CategoryName": "General Business",
        "StatusReason": null,
        "InitiatingCompanyId": 19,
        "HasApprovalRoute": false,
        "VendorApprovals": [],
        "NextVendorApproval": null
    }, {
        "Id": "dba87297-1bac-4d02-8a70-8c5de154d325",
        "ContactSurname": "Justin",
        "ContactFirstname": "Chinwe",
        "ContactEmailAddress": "dare.medunoye@heirsinsurance.com",
        "ContactPhoneNumber": "+2348064015028",
        "VendorName": "Microsoft",
        "VendorStatus": 5,
        "VendorStatusName": "Awaiting Approval",
        "CategoryName": "Technology",
        "StatusReason": null,
        "InitiatingCompanyId": 19,
        "HasApprovalRoute": true,
        "VendorApprovals": [
            {
                "ApprovalSettingId": 1,
                "ApprovalUserId": 1,
                "ApprovalUserName": "string",
                "VendorStatus": 5,
                "VendorStatusName": "Awaiting Approval",
                "ReasonOfRejection": "string",
                "OrderBy": 0
            }
        ],
        "NextVendorApproval": {
            "ApprovalSettingId": 1,
            "ApprovalUserId": 1,
            "ApprovalUserName": "string",
            "VendorStatus": 5,
            "VendorStatusName": "Awaiting Approval",
            "ReasonOfRejection": "string",
            "OrderBy": 0
        }
    }, {
        "Id": "e2fd0faa-b35e-46df-99ff-6b63db01a812",
        "ContactSurname": "Department",
        "ContactFirstname": "Sales",
        "ContactEmailAddress": "sales@zoom.us",
        "ContactPhoneNumber": "+2348184340923",
        "VendorName": "Zoom Video Communications, Inc",
        "VendorStatus": 0,
        "VendorStatusName": "Pending",
        "CategoryName": "Telecoms",
        "StatusReason": null,
        "InitiatingCompanyId": 19,
        "HasApprovalRoute": false,
        "VendorApprovals": [],
        "NextVendorApproval": null
    }, {
        "Id": "01626e28-642b-428f-ae71-9a77a362ab5b",
        "ContactSurname": "Gold",
        "ContactFirstname": "Friso",
        "ContactEmailAddress": "friso@sharklasers.com",
        "ContactPhoneNumber": "+2348098368736",
        "VendorName": "Samsung Supplier",
        "VendorStatus": 5,
        "VendorStatusName": "Awaiting Approval",
        "CategoryName": "Supply Chain",
        "StatusReason": null,
        "InitiatingCompanyId": 19,
        "HasApprovalRoute": true,
        "VendorApprovals": [
            {
                "ApprovalSettingId": 1,
                "ApprovalUserId": 3,
                "ApprovalUserName": "string",
                "VendorStatus": 5,
                "VendorStatusName": "Awaiting Approval",
                "ReasonOfRejection": "string",
                "OrderBy": 0
            }
        ],
        "NextVendorApproval": {
            "ApprovalSettingId": 1,
            "ApprovalUserId": 3,
            "ApprovalUserName": "string",
            "VendorStatus": 5,
            "VendorStatusName": "Awaiting Approval",
            "ReasonOfRejection": "string",
            "OrderBy": 0
        }
    }, {
        "Id": "12b0368b-65ce-4e04-bb75-0e2ce5b076b1",
        "ContactSurname": "Akowe",
        "ContactFirstname": "Lekan",
        "ContactEmailAddress": "lakowe@sharklasers.com",
        "ContactPhoneNumber": "+2348077662602",
        "VendorName": "Gorimapa Enterprises",
        "VendorStatus": 1,
        "VendorStatusName": "Approved",
        "CategoryName": "General Business",
        "StatusReason": null,
        "InitiatingCompanyId": 19,
        "HasApprovalRoute": false,
        "VendorApprovals": [],
        "NextVendorApproval": null
    }, {
        "Id": "f7cad42b-c43f-4c87-8667-b1431031d06f",
        "ContactSurname": "Nita",
        "ContactFirstname": "Jallas",
        "ContactEmailAddress": "anitajallas@gmail.com",
        "ContactPhoneNumber": "+2348132271639",
        "VendorName": "flora",
        "VendorStatus": 0,
        "VendorStatusName": "Pending",
        "CategoryName": "Fabric",
        "StatusReason": null,
        "InitiatingCompanyId": 19,
        "HasApprovalRoute": false,
        "VendorApprovals": [],
        "NextVendorApproval": null
    }, {
        "Id": "e82c0f90-b7be-45f3-acb4-70afea902216",
        "ContactSurname": "Jallas",
        "ContactFirstname": "Anita",
        "ContactEmailAddress": "anitajallas@yahoo.com",
        "ContactPhoneNumber": "+2348132271639",
        "VendorName": "jallasB",
        "VendorStatus": 5,
        "VendorStatusName": "Awaiting Approval",
        "CategoryName": "Technology",
        "StatusReason": null,
        "InitiatingCompanyId": 19,
        "HasApprovalRoute": false,
        "VendorApprovals": [],
        "NextVendorApproval": null
    }, {
        "Id": "68e913fb-ac11-4612-a246-976aed90a46d",
        "ContactSurname": "Soyombo",
        "ContactFirstname": "Deborah",
        "ContactEmailAddress": "itops@heirsinsurance.com",
        "ContactPhoneNumber": "+2348064015028",
        "VendorName": "Milky Express",
        "VendorStatus": 5,
        "VendorStatusName": "Awaiting Approval",
        "CategoryName": "Automobiles",
        "StatusReason": null,
        "InitiatingCompanyId": 19,
        "HasApprovalRoute": false,
        "VendorApprovals": [],
        "NextVendorApproval": null
    }, {
        "Id": "e1686191-c4ed-42c7-ad10-734b4d651d22",
        "ContactSurname": "Adigun",
        "ContactFirstname": "Khadijat",
        "ContactEmailAddress": "kadigun@sharklasers.com",
        "ContactPhoneNumber": "+2348076635353",
        "VendorName": "Kadigun Enterprises",
        "VendorStatus": 5,
        "VendorStatusName": "Awaiting Approval",
        "CategoryName": "Fabric",
        "StatusReason": null,
        "InitiatingCompanyId": 19,
        "HasApprovalRoute": false,
        "VendorApprovals": [],
        "NextVendorApproval": null
    }]
}

export const FIND_VENDORS = [
    {
        "Id": "74cb4c29-3dd4-49c9-ad12-2cfd2ff82947",
        "VendorName": "Aromire Tech Solutions"
    }, {
        "Id": "1963b89f-fc45-48c5-ae8e-ab97273146a0",
        "VendorName": "SKG Technologies"
    }, {
        "Id": "a9e5a652-d76c-43cd-bb96-2e69ad768d14",
        "VendorName": "Remitrix Technologies"
    }
]

export const CHECK_VENDOR_EMAIL = [
    {
        "Id": "43b9e979-61a1-4bf7-8c10-a2ac65c2ac3e",
        "VendorName": "Lambert Clerk"
    }
]

export const GET_VENDOR_BY_ID = {
    "Address": null,
    "ResidenceType": 0,
    "ResidenceTypeName": "Unknown",
    "Occupation": null,
    "CategoryId": 9,
    "VendorType": 1,
    "VendorTypeName": "Business Name",
    "InitiatingCompanyName": "Test Company",
    "HasApprovalRoute": false,
    "DirectorSignature": null,
    "SecretarySignature": null,
    "VendorDocumentStatus": {
        "Vendor": "Labamba Technologies",
        "ApprovedDocumentCount": 0,
        "PendingDocumentCount": 1,
        "RejectedDocumentCount": 0,
        "TotalDocumentCount": 1,
        "ApprovedDocumentPercent": 0,
        "PendingDocumentPercent": 100,
        "RejectedDocumentPercent": 0
    },
    "Contacts": [{
        "Id": "08d9301f-152d-49a2-8869-9d7c3a7cee14",
        "Title": "Mr.",
        "Surname": "Dagunro",
        "Firstname": "Oluwatobi",
        "EmailAddress": "o.dadunro@sharklasers.com",
        "MobileNumber": "8093383838",
        "HomeNumber": null,
        "OfficeNumber": null,
        "PreviousName": null,
        "Alaises": null,
        "Address": "Illupeju Lagos",
        "MailingAddress": null,
        "ResidenceType": 1,
        "ResidenceTypeName": "Self Owned",
        "Occupation": null,
        "IdCardURL": null,
        "ContactPassport": {
            "Id": "00000000-0000-0000-0000-000000000000",
            "Nationality": null,
            "PassportNumber": null,
            "DateOfIssue": null,
            "PlaceOfIssue": null,
            "DateOfExpiry": null,
            "IdNumber": null,
            "IdCardUrl": null
        }
    }],
    "Account": {
        "Id": "08d93021-d135-4724-82c5-457a144d17c6",
        "Bank": 0,
        "BankName": "Access Bank Plc",
        "OtherBankName": null,
        "AccountName": "Lambaba Loki",
        "AccountNumber": "9490930943",
        "Address": "Victoria Island",
        "SortCode": "339-939-11",
        "TIN": "K33393441"
    },
    "Documents": [{
        "DocumentTypeId": 1,
        "DocumentType": "Copy of a Certificate of Incorporation or Registration of Business Name or \nCertificate to Trade",
        "DocumentUrl": "sample-1623779887005.pdf",
        "CreatedDate": "2021-06-15T17:58:09.718645",
        "DocumentSize": "0.01",
        "Status": 0,
        "StatusName": "Pending",
        "ExpiryDate": null
    }],
    "VendorApprovals": [],
    "NextVendorApproval": null,
    "Answers": [{
        "VendorTypeQuestionId": "018beff2-c255-47a6-b248-9eb26a93dad5",
        "VendorTypeQuestion": "Do you have any cybersecurity certifications for \nyour organisation? \nIf yes, please provide details of the technical and \norganisational measures that are a part of your data security architecture, including the information \nsecurity certifications that you hold.",
        "Answer": "Yes",
        "OptionSelected": null,
        "OptionSelectedName": ""
    }, {
        "VendorTypeQuestionId": "1b9b1e82-eae1-4586-8845-3e212f1f1903",
        "VendorTypeQuestion": "Email Address",
        "Answer": "bamba@yahoo.com",
        "OptionSelected": null,
        "OptionSelectedName": ""
    }, {
        "VendorTypeQuestionId": "1fb69015-b1bf-4cee-b949-6b542aece849",
        "VendorTypeQuestion": "Are all staff, agents and key subcontractors used to \ndeliver similar contracts subject to contractual \nobligations of confidentiality which complies with \nthe NDPR and/or other applicable Data Protection \nregulation?\n",
        "Answer": "Yes",
        "OptionSelected": null,
        "OptionSelectedName": ""
    }, {
        "VendorTypeQuestionId": "27ef76bf-5d49-4e5b-bf30-6c042ddcfbf5",
        "VendorTypeQuestion": "Registered Address",
        "Answer": "Illupeju",
        "OptionSelected": null,
        "OptionSelectedName": ""
    }, {
        "VendorTypeQuestionId": "2a4996a9-1398-4444-b780-0bcebcdde1f8",
        "VendorTypeQuestion": "Does your organisation have data privacy and \nprotection policies and notices in place? \nIf yes, please enumerate the current policies and \nnotices and provide details of the last time it was \nreviewed or updated.",
        "Answer": "No",
        "OptionSelected": null,
        "OptionSelectedName": ""
    }, {
        "VendorTypeQuestionId": "3572b7f0-89fb-4cb8-818a-c8456dc9540f",
        "VendorTypeQuestion": "Please provide names, designation and nationality \nof all company directors (or equivalent in your \njurisdiction of incorporation).\n",
        "Answer": "Bamba Durotoye",
        "OptionSelected": null,
        "OptionSelectedName": ""
    }, {
        "VendorTypeQuestionId": "37e3c13e-c17d-4747-bffa-31800a4a3e57",
        "VendorTypeQuestion": "Date of Incorporation\n",
        "Answer": "2020-01-01",
        "OptionSelected": null,
        "OptionSelectedName": ""
    }, {
        "VendorTypeQuestionId": "3bd794c1-c39a-4fff-8ae4-60db9f2edf45",
        "VendorTypeQuestion": "Do you agree that HH can share any of the \ninformation provided herein with external parties \nsuch as external auditors, external evaluators, \npartners and donors for any required evaluation \nassessment, audit or inspection?\n",
        "Answer": null,
        "OptionSelected": "dbff6abf-f9bd-4f51-8224-adaf5be9747a",
        "OptionSelectedName": "Yes"
    }, {
        "VendorTypeQuestionId": "40171739-bf3b-466a-834d-ac6ab390b2c6",
        "VendorTypeQuestion": "Registration Number",
        "Answer": "BN122939393",
        "OptionSelected": null,
        "OptionSelectedName": ""
    }, {
        "VendorTypeQuestionId": "4f0e94c5-d170-4f17-b79d-197aabc84b87",
        "VendorTypeQuestion": "Will or may any Public Official or a Close Family \nMember of a Public Official receive a pecuniary \nbenefit if HH executes a contract with your \ncompany?\nIf “Yes”, please identify the Public Official or the\nClose Family Member of the Public Official and \ndescribe the benefit that he or she will or may \nreceive.",
        "Answer": "No",
        "OptionSelected": null,
        "OptionSelectedName": ""
    }, {
        "VendorTypeQuestionId": "5ab874c9-8671-4eaa-8a69-ab32e5f934d3",
        "VendorTypeQuestion": "Website link",
        "Answer": "www.bamba.com",
        "OptionSelected": null,
        "OptionSelectedName": ""
    }, {
        "VendorTypeQuestionId": "5c59eaf0-2e3b-4ae3-89ca-b7431a8a0775",
        "VendorTypeQuestion": "Key objects and principal business activities",
        "Answer": "General Business",
        "OptionSelected": null,
        "OptionSelectedName": ""
    }, {
        "VendorTypeQuestionId": "611c285a-f261-4363-ae06-399ca1ed9041",
        "VendorTypeQuestion": "Please provide names, designation and nationality \nof all executive management staff (or equivalent in \nyour jurisdiction of incorporation).",
        "Answer": "Bamba Durotoye",
        "OptionSelected": null,
        "OptionSelectedName": ""
    }, {
        "VendorTypeQuestionId": "726a982a-881e-46ec-b46b-d787bdfa7b10",
        "VendorTypeQuestion": "n the event that you decide to sub-contract part of \nthis work to another contractor who will process \npersonal information of data subjects within the \nscope of the engagement, do you have \ncontractual provisions in place that will compel the \nsub–contractor to comply with the provisions of the \nNDPR and/or other applicable Data Protection \nregulation?\n",
        "Answer": "Yes",
        "OptionSelected": null,
        "OptionSelectedName": ""
    }, {
        "VendorTypeQuestionId": "73cb97ca-51dd-4686-bdb9-4fba1ac43912",
        "VendorTypeQuestion": "Are any of the officers, directors, shareholders, \nUltimate Beneficial Owners, a Public Official or a \nClose Family Member of a Public Official (as defined \nat the end of this questionnaire)\nIf “Yes”, please provide:\n• Name\n• Position in/Relationship to your Company\n• Position in \nGovernment/Agency/Organization/Political \nParty.",
        "Answer": "eee",
        "OptionSelected": null,
        "OptionSelectedName": ""
    }, {
        "VendorTypeQuestionId": "7b37db0a-e10e-41db-bf79-e123dee947be",
        "VendorTypeQuestion": "Are you likely to transfer abroad any personal data \nderived from your engagement with HH",
        "Answer": "No",
        "OptionSelected": null,
        "OptionSelectedName": ""
    }, {
        "VendorTypeQuestionId": "7b877b93-e750-4265-ad50-096d11d05a1d",
        "VendorTypeQuestion": "Have you received any complaint from a data \nsubject within the last 12 months about the use or \nmisuse of personal data?\nIf yes, please provide the details.",
        "Answer": "No",
        "OptionSelected": null,
        "OptionSelectedName": ""
    }, {
        "VendorTypeQuestionId": "86cad651-18f4-4f61-a7a8-e1e8a27ebb59",
        "VendorTypeQuestion": "Has your organisation conducted Data Privacy and \nProtection Awareness trainings within the last 12 \nmonths? ",
        "Answer": "Yes",
        "OptionSelected": null,
        "OptionSelectedName": ""
    }, {
        "VendorTypeQuestionId": "8ae17d82-0a1f-4dc2-bdd3-56f9f4f29f5d",
        "VendorTypeQuestion": "s the Company in good standing with authorities \nwith jurisdiction over it?",
        "Answer": null,
        "OptionSelected": "5b25d02a-6df9-4622-ab90-55ee9931e448",
        "OptionSelectedName": "Yes"
    }, {
        "VendorTypeQuestionId": "8d272a4b-7ab4-45c4-afaa-f0271036881a",
        "VendorTypeQuestion": "Has your company or any, directors, officers or \nUltimate Beneficial Owners of your company been \na target of a criminal or civil investigation or \nproceeding during the past five years involving \nallegations relating to bribery, fraud, money \nlaundering, financing of terrorism, misleading \nrecord keeping or financial control deficiencies?\nIf “Yes”, please describe the allegations that were \nmade, how the allegations were resolved or, if not resolved, the current status of the investigation or \nproceeding (Attach additional pages as needed).",
        "Answer": "Yes. Manager was acquited",
        "OptionSelected": null,
        "OptionSelectedName": ""
    }, {
        "VendorTypeQuestionId": "925a2c9d-f442-440f-8a79-9ff0eca7a5c3",
        "VendorTypeQuestion": "Country of Incorporation",
        "Answer": "Nigeria",
        "OptionSelected": null,
        "OptionSelectedName": ""
    }, {
        "VendorTypeQuestionId": "9cb32c98-c1f4-4c49-83cf-44a899b4b6d6",
        "VendorTypeQuestion": "Have you reported any data breach incident to the \nNational Information Technology Development \nAgency (NITDA) or any other Data Protection \nregulator? ",
        "Answer": "No",
        "OptionSelected": null,
        "OptionSelectedName": ""
    }, {
        "VendorTypeQuestionId": "9e883ef0-2dc7-4cd5-aca9-d4e1a21a924e",
        "VendorTypeQuestion": "Please confirm that your organisation complies with \nthe provisions of the Nigeria Data Protection \nRegulation (NDPR) and/or other data protection \nregulations and legislation (please specify others).\n",
        "Answer": "No",
        "OptionSelected": null,
        "OptionSelectedName": ""
    }, {
        "VendorTypeQuestionId": "afc2de94-5314-4e7c-9585-5deb6de5e696",
        "VendorTypeQuestion": "s the Company subject to AML/CFT regulations in \nany jurisdiction?\n",
        "Answer": null,
        "OptionSelected": "e4c0a9a8-a0eb-45a3-b1d4-b3862fcfbe0c",
        "OptionSelectedName": "Yes"
    }, {
        "VendorTypeQuestionId": "b5d0c041-3f3b-49cc-a526-3f4c38112cd4",
        "VendorTypeQuestion": "Please provide the names, designation and \nnationality of the person(s) principally responsible for \nthe relationship with HH.",
        "Answer": "Mr. Danguro",
        "OptionSelected": null,
        "OptionSelectedName": ""
    }, {
        "VendorTypeQuestionId": "b6f63418-a1f8-40fa-b09e-a24ed8571107",
        "VendorTypeQuestion": "Do you have a Data Protection Officer?\nIf yes, provide his/her job description and confirm \nwhether or not he is playing that role adequately.",
        "Answer": "Yes",
        "OptionSelected": null,
        "OptionSelectedName": ""
    }, {
        "VendorTypeQuestionId": "bb591001-b97c-4de0-a508-58d9dad99403",
        "VendorTypeQuestion": "Telephone Number",
        "Answer": "0809773536",
        "OptionSelected": null,
        "OptionSelectedName": ""
    }, {
        "VendorTypeQuestionId": "c4dcaa09-718f-4144-bc92-8b11935ba33c",
        "VendorTypeQuestion": "Please provide names of all direct or indirect owners \nof your company together with their ownership \npercentages (See explanatory note below).",
        "Answer": "No",
        "OptionSelected": null,
        "OptionSelectedName": ""
    }, {
        "VendorTypeQuestionId": "c5ae716b-796b-40e1-a7a9-15fa19a2d0e3",
        "VendorTypeQuestion": "Type of Organisation",
        "Answer": "Lotto",
        "OptionSelected": null,
        "OptionSelectedName": ""
    }, {
        "VendorTypeQuestionId": "d25e9413-8faf-49b7-9847-31649ee0e014",
        "VendorTypeQuestion": "Name of Entity",
        "Answer": "Lambaba Enterprises",
        "OptionSelected": null,
        "OptionSelectedName": ""
    }, {
        "VendorTypeQuestionId": "e1b109c3-1178-4a27-a7e9-ebfbc4f8c30d",
        "VendorTypeQuestion": "Please provide name(s), designation and \nnationality of person(s) authorised to sign the \nContract on behalf of the entity",
        "Answer": "eee",
        "OptionSelected": null,
        "OptionSelectedName": ""
    }, {
        "VendorTypeQuestionId": "e9eac331-7670-4fd4-98cc-c69e91e309c8",
        "VendorTypeQuestion": "Principal Place of business",
        "Answer": "Illupeju",
        "OptionSelected": null,
        "OptionSelectedName": ""
    }, {
        "VendorTypeQuestionId": "ea8a81e8-a642-405e-9f1f-90996e80c337",
        "VendorTypeQuestion": "Is any of the Company’s owners/Ultimate Beneficial \nOwners or executive management (or Close Family \nMember of any of them) a staff member, appointed\nofficer of HH?\nIf “Yes”, please provide:\n• Name\n• Position in/Relationship to HH",
        "Answer": "No",
        "OptionSelected": null,
        "OptionSelectedName": ""
    }, {
        "VendorTypeQuestionId": "f2212039-e804-487f-8c9e-2783b2eb10e1",
        "VendorTypeQuestion": "Have you had any data breach in the last 12 \nmonths?\nIf yes, please provide a summary of the breach. ",
        "Answer": "No",
        "OptionSelected": null,
        "OptionSelectedName": ""
    }, {
        "VendorTypeQuestionId": "f2f76ef8-c33d-42f0-b9d4-c2d132909d9c",
        "VendorTypeQuestion": "Has any of the Company’s owners/Ultimate\nBeneficial Owners or executive management (or \nClose Family Member of any of them) been a staff \nmember, appointed officer of HH in the last 3 years?\nIf “Yes”, please provide:\n• Name\n• Position in/Relationship to HH\n• Year resigned\n",
        "Answer": "No",
        "OptionSelected": null,
        "OptionSelectedName": ""
    }, {
        "VendorTypeQuestionId": "fcd8cb95-a78f-41e9-a1fa-adf2c8f20fd3",
        "VendorTypeQuestion": "Do you confirm that the individuals and companies \nidentified herein have been notified of and have \nconsented to the transfer (within or outside Nigeria), \nstorage and processing of such personal \ninformation if required by us for any reason and in \naccordance with the NDPR and other terms \ndetailed in the Data Protection and Privacy Policy \nof HH available here",
        "Answer": "eee",
        "OptionSelected": null,
        "OptionSelectedName": ""
    }],
    "Id": "1eb5d2bc-aa0f-4f5f-9eaa-c18ff08aedb3",
    "ContactSurname": "Durotoye",
    "ContactFirstname": "Bamba",
    "ContactEmailAddress": "b.durotoye@sharklasers.com",
    "ContactPhoneNumber": "+3588077662602",
    "VendorName": "Labamba Technologies",
    "VendorStatus": 0,
    "VendorStatusName": "Pending",
    "CategoryName": "General Business",
    "StatusReason": null,
    "InitiatingCompanyId": 19
}

export const GET_VENDOR_DOCUMENT = "data:image/png;base64,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"

export const VENDOR_CREDENTIALS = {
    "VendorStatus": 0,
    "IsVendorApproved": false,
    "IsVendorBlacklisted": false,
    "IsVendorRejected": false,
    "IsVendorRegistrationPending": true,
    "MustChangePassword": false,
    "JWTToken": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJWZW5kb3JFbWFpbCI6ImNrZGFmMjAwMEB5YWhvby5jby51ayIsIlZlbmRvcklkIjoiNDNiOWU5NzktNjFhMS00YmY3LThjMTAtYTJhYzY1YzJhYzNlIiwiaXNWZW5kb3IiOiJ0cnVlIiwiVmVuZG9yVHlwZSI6IkJ1c2luZXNzIE5hbWUiLCJWZW5kb3JUeXBlSWQiOiIxIiwiSW5pdGlhdGluZ0NvbXBhbnlJZCI6IjE5IiwiY29tcGFueUxvZ29VcmwiOiJodHRwczovL3Byb2Nlc3NmbG93LmhoLWNvbnZlcmdlLmNvbS9leHAvcGcvbG9nby5hc3B4P2NpZD0xOSIsIm5iZiI6MTYyMzE0NTE5MCwiZXhwIjoxNjIzNzQ5OTkwLCJpYXQiOjE2MjMxNDUxOTB9.157QKHq3HKPn1OohXoUKaA3TjS5X_IHiQcDHITfYuRQ",
    "ExpiringDate": "2021-06-15T09:39:50.6686311Z",
    "AcceptTermAndConditions": false
}

export const MY_VENDOR_INFO = {
    "Address": null,
    "ResidenceType": 0,
    "ResidenceTypeName": "Unknown",
    "Occupation": null,
    "CategoryId": 11,
    "VendorType": 2,
    "VendorTypeName": "Incorporated Bodies",
    "InitiatingCompanyName": "Test Company",
    "DirectorSignature": "mosquito-1623179912612.png",
    "SecretarySignature": "rocket-1623179907091.png",
    "VendorDocumentStatus": {
        "Vendor": "Samsung Supplier",
        "ApprovedDocumentCount": 0,
        "PendingDocumentCount": 1,
        "RejectedDocumentCount": 0,
        "TotalDocumentCount": 1,
        "ApprovedDocumentPercent": 0,
        "PendingDocumentPercent": 100,
        "RejectedDocumentPercent": 0
    },
    "Contacts": [{
        "Id": "08d92ab2-3c2b-492f-80a7-fea248a90a35",
        "Title": "Mr.",
        "Surname": "Samsung",
        "Firstname": "Owner",
        "EmailAddress": "sam_sung@sharklasers.com",
        "MobileNumber": "+2348093476384",
        "HomeNumber": null,
        "OfficeNumber": null,
        "PreviousName": null,
        "Alaises": null,
        "Address": "Samsung Villa, Villareal",
        "MailingAddress": null,
        "ResidenceType": 1,
        "ResidenceTypeName": "Self Owned",
        "Occupation": null,
        "IdCardURL": "rocket-1623746520106.png",
        "ContactPassport": {
            "Id": "00000000-0000-0000-0000-000000000000",
            "Nationality": null,
            "PassportNumber": null,
            "DateOfIssue": null,
            "PlaceOfIssue": null,
            "DateOfExpiry": null,
            "IdNumber": null,
            "IdCardUrl": null
        }
    }],
    "Account": {
        "Id": "08d92ab2-3c23-455b-80c8-18f5610b86de",
        "Bank": "Access Bank PLC",
        "AccountName": "Samsung Shark Nigeria PLC",
        "AccountNumber": "0747484747",
        "Address": "Victoria Island, Lagos Nigeria",
        "SortCode": "098-949-9982",
        "TIN": null
    },
    "Documents": [{
        "DocumentTypeId": 3,
        "DocumentType": "Most recent  Curriculum Vitae/Resume/Profile",
        "DocumentUrl": "sample-1623179898222.pdf",
        "CreatedDate": "2021-06-08T19:18:43.645951",
        "DocumentSize": "0.03",
        "Status": 0,
        "StatusName": "Pending"
    }],
    "Answers": [{
        "VendorTypeQuestionId": "1740792e-415a-4240-a778-72d5bed009ac",
        "VendorTypeQuestion": "When did you start?",
        "Answer": "1987",
        "OptionSelected": null,
        "OptionSelectedName": ""
    }, {
        "VendorTypeQuestionId": "572486c9-f9c0-420f-974e-f34916bff18b",
        "VendorTypeQuestion": "Is your company product/system registered to any quality management system or porduct standard?",
        "Answer": "Yes",
        "OptionSelected": null,
        "OptionSelectedName": ""
    }],
    "Id": "01626e28-642b-428f-ae71-9a77a362ab5b",
    "ContactSurname": "Gold",
    "ContactFirstname": "Friso",
    "ContactEmailAddress": "friso@sharklasers.com",
    "ContactPhoneNumber": "+2348098368736",
    "VendorName": "Samsung Supplier",
    "VendorStatus": 5,
    "VendorStatusName": "Awaiting Approval",
    "CategoryName": "Supply Chain",
    "StatusReason": null,
    "InitiatingCompanyId": 19
}

export const GET_COUNTRIES = [
    {
        "Id": 1,
        "Name": "Afghanistan"
    },
    {
        "Id": 2,
        "Name": "Albania"
    },
    {
        "Id": 3,
        "Name": "Algeria"
    },
    {
        "Id": 4,
        "Name": "Andorra"
    },
    {
        "Id": 5,
        "Name": "Angola"
    },
    {
        "Id": 6,
        "Name": "Antigua and Barbuda"
    },
    {
        "Id": 7,
        "Name": "Argentina"
    },
    {
        "Id": 8,
        "Name": "Armenia"
    },
    {
        "Id": 9,
        "Name": "Australia"
    },
    {
        "Id": 10,
        "Name": "Austria"
    },
    {
        "Id": 11,
        "Name": "Azerbaijan"
    },
    {
        "Id": 12,
        "Name": "Bahamas"
    },
    {
        "Id": 13,
        "Name": "Bahrain"
    },
    {
        "Id": 14,
        "Name": "Bangladesh"
    },
    {
        "Id": 15,
        "Name": "Barbados"
    },
    {
        "Id": 16,
        "Name": "Belarus"
    },
    {
        "Id": 17,
        "Name": "Belgium"
    },
    {
        "Id": 18,
        "Name": "Belize"
    },
    {
        "Id": 19,
        "Name": "Benin"
    },
    {
        "Id": 20,
        "Name": "Bhutan"
    },
    {
        "Id": 21,
        "Name": "Bolivia"
    },
    {
        "Id": 22,
        "Name": "Bosnia and Herzegovina"
    },
    {
        "Id": 23,
        "Name": "Botswana"
    },
    {
        "Id": 24,
        "Name": "Brazil"
    },
    {
        "Id": 25,
        "Name": "Brunei"
    },
    {
        "Id": 26,
        "Name": "Bulgaria"
    },
    {
        "Id": 27,
        "Name": "Burkina Faso"
    },
    {
        "Id": 28,
        "Name": "Burundi"
    },
    {
        "Id": 29,
        "Name": " Cabo Verde"
    },
    {
        "Id": 30,
        "Name": "Cambodia"
    },
    {
        "Id": 31,
        "Name": "Cameroon"
    },
    {
        "Id": 32,
        "Name": "Canada"
    },
    {
        "Id": 33,
        "Name": "Central African Republic (CAR)"
    },
    {
        "Id": 34,
        "Name": "Chad"
    },
    {
        "Id": 35,
        "Name": "Chile"
    },
    {
        "Id": 36,
        "Name": "China"
    },
    {
        "Id": 37,
        "Name": "Colombia"
    },
    {
        "Id": 38,
        "Name": "Comoros"
    },
    {
        "Id": 39,
        "Name": "Congo, Democratic Republic"
    },
    {
        "Id": 40,
        "Name": "Costa Rica"
    },
    {
        "Id": 41,
        "Name": "Cote d'Ivoire"
    },
    {
        "Id": 42,
        "Name": "Croatia"
    },
    {
        "Id": 43,
        "Name": "Cuba"
    },
    {
        "Id": 44,
        "Name": "Cyprus"
    },
    {
        "Id": 45,
        "Name": "Czechia"
    },
    {
        "Id": 46,
        "Name": "Denmark"
    },
    {
        "Id": 47,
        "Name": "Djibouti"
    },
    {
        "Id": 48,
        "Name": "Dominica"
    },
    {
        "Id": 49,
        "Name": "Dominican Republic"
    },
    {
        "Id": 50,
        "Name": "Ecuador"
    },
    {
        "Id": 51,
        "Name": "Egypt"
    },
    {
        "Id": 52,
        "Name": "El Salvador"
    },
    {
        "Id": 53,
        "Name": "Equatorial Guinea"
    },
    {
        "Id": 54,
        "Name": "Eritrea"
    },
    {
        "Id": 55,
        "Name": "Estonia"
    },
    {
        "Id": 56,
        "Name": "Eswatini (formerly Swaziland)"
    },
    {
        "Id": 57,
        "Name": "Ethiopia"
    },
    {
        "Id": 58,
        "Name": "Fiji"
    },
    {
        "Id": 59,
        "Name": "Finland"
    },
    {
        "Id": 60,
        "Name": "France"
    },
    {
        "Id": 61,
        "Name": "Gabon"
    },
    {
        "Id": 62,
        "Name": "Gambia"
    },
    {
        "Id": 63,
        "Name": "Georgia"
    },
    {
        "Id": 64,
        "Name": "Germany"
    },
    {
        "Id": 65,
        "Name": "Ghana"
    },
    {
        "Id": 66,
        "Name": "Greece"
    },
    {
        "Id": 67,
        "Name": "Grenada"
    },
    {
        "Id": 68,
        "Name": "Guatemala"
    },
    {
        "Id": 69,
        "Name": "Guinea"
    },
    {
        "Id": 70,
        "Name": "Guinea-Bissau"
    },
    {
        "Id": 71,
        "Name": "Guyana"
    },
    {
        "Id": 72,
        "Name": "Haiti"
    },
    {
        "Id": 73,
        "Name": "Honduras"
    },
    {
        "Id": 74,
        "Name": "Hungary"
    },
    {
        "Id": 75,
        "Name": "Iceland"
    },
    {
        "Id": 76,
        "Name": "India"
    },
    {
        "Id": 77,
        "Name": "Indonesia"
    },
    {
        "Id": 78,
        "Name": "Iran"
    },
    {
        "Id": 79,
        "Name": "Iraq"
    },
    {
        "Id": 80,
        "Name": "Ireland"
    },
    {
        "Id": 81,
        "Name": "Israel"
    },
    {
        "Id": 82,
        "Name": "Italy"
    },
    {
        "Id": 83,
        "Name": "Jamaica"
    },
    {
        "Id": 84,
        "Name": "Japan"
    },
    {
        "Id": 85,
        "Name": "Jordan"
    },
    {
        "Id": 86,
        "Name": "Kazakhstan"
    },
    {
        "Id": 87,
        "Name": "Kenya"
    },
    {
        "Id": 88,
        "Name": "Kiribati"
    },
    {
        "Id": 89,
        "Name": "Kosovo"
    },
    {
        "Id": 90,
        "Name": "Kuwait"
    },
    {
        "Id": 91,
        "Name": "Kyrgyzstan"
    },
    {
        "Id": 92,
        "Name": "Laos"
    },
    {
        "Id": 93,
        "Name": "Latvia"
    },
    {
        "Id": 94,
        "Name": "Lebanon"
    },
    {
        "Id": 95,
        "Name": "Lesotho"
    },
    {
        "Id": 96,
        "Name": "Liberia"
    },
    {
        "Id": 97,
        "Name": "Libya"
    },
    {
        "Id": 98,
        "Name": "Liechtenstein"
    },
    {
        "Id": 99,
        "Name": "Lithuania"
    },
    {
        "Id": 100,
        "Name": "Luxembourg"
    },
    {
        "Id": 101,
        "Name": "Madagascar"
    },
    {
        "Id": 102,
        "Name": "Malawi"
    },
    {
        "Id": 103,
        "Name": "Malaysia"
    },
    {
        "Id": 104,
        "Name": "Maldives"
    },
    {
        "Id": 105,
        "Name": "Mali"
    },
    {
        "Id": 106,
        "Name": "Malta"
    },
    {
        "Id": 107,
        "Name": "Marshall Islands"
    },
    {
        "Id": 108,
        "Name": "Mauritania"
    },
    {
        "Id": 109,
        "Name": "Mauritius"
    },
    {
        "Id": 110,
        "Name": "Mexico"
    },
    {
        "Id": 111,
        "Name": "Micronesia"
    },
    {
        "Id": 112,
        "Name": "Moldova"
    },
    {
        "Id": 113,
        "Name": "Monaco"
    },
    {
        "Id": 114,
        "Name": "Mongolia"
    },
    {
        "Id": 115,
        "Name": "Montenegro"
    },
    {
        "Id": 116,
        "Name": "Morocco"
    },
    {
        "Id": 117,
        "Name": "Mozambique"
    },
    {
        "Id": 118,
        "Name": "Myanmar (formerly Burma)"
    },
    {
        "Id": 119,
        "Name": "Namibia"
    },
    {
        "Id": 120,
        "Name": "Nauru"
    },
    {
        "Id": 121,
        "Name": "Nepal"
    },
    {
        "Id": 122,
        "Name": "Netherlands"
    },
    {
        "Id": 123,
        "Name": "New Zealand"
    },
    {
        "Id": 124,
        "Name": "Nicaragua"
    },
    {
        "Id": 125,
        "Name": "Niger"
    },
    {
        "Id": 126,
        "Name": "Nigeria"
    },
    {
        "Id": 127,
        "Name": "North Korea"
    },
    {
        "Id": 128,
        "Name": "North Macedonia (formerly Macedonia)"
    },
    {
        "Id": 129,
        "Name": "Norway"
    },
    {
        "Id": 130,
        "Name": "Oman"
    },
    {
        "Id": 131,
        "Name": "Pakistan"
    },
    {
        "Id": 132,
        "Name": "Palau"
    },
    {
        "Id": 133,
        "Name": "Palestine"
    },
    {
        "Id": 134,
        "Name": "Panama"
    },
    {
        "Id": 135,
        "Name": " Papua New Guinea"
    },
    {
        "Id": 136,
        "Name": "Paraguay"
    },
    {
        "Id": 137,
        "Name": "Peru"
    },
    {
        "Id": 138,
        "Name": "Philippines"
    },
    {
        "Id": 139,
        "Name": "Poland"
    },
    {
        "Id": 140,
        "Name": "Portugal"
    },
    {
        "Id": 141,
        "Name": "Qatar"
    },
    {
        "Id": 142,
        "Name": "Romania"
    },
    {
        "Id": 143,
        "Name": "Russia"
    },
    {
        "Id": 144,
        "Name": "Rwanda"
    },
    {
        "Id": 145,
        "Name": "Saint Kitts and Nevis"
    },
    {
        "Id": 146,
        "Name": "Saint Lucia"
    },
    {
        "Id": 147,
        "Name": "Saint Vincent and the Grenadines"
    },
    {
        "Id": 148,
        "Name": "Samoa"
    },
    {
        "Id": 149,
        "Name": "San Marino"
    },
    {
        "Id": 150,
        "Name": "Sao Tome and Principe"
    },
    {
        "Id": 151,
        "Name": "Saudi Arabia"
    },
    {
        "Id": 152,
        "Name": "Senegal"
    },
    {
        "Id": 153,
        "Name": "Serbia"
    },
    {
        "Id": 154,
        "Name": "Seychelles"
    },
    {
        "Id": 155,
        "Name": "Sierra Leone"
    },
    {
        "Id": 156,
        "Name": "Singapore"
    },
    {
        "Id": 157,
        "Name": "Slovakia"
    },
    {
        "Id": 158,
        "Name": "Slovenia"
    },
    {
        "Id": 159,
        "Name": "Solomon Islands"
    },
    {
        "Id": 160,
        "Name": "Somalia"
    },
    {
        "Id": 161,
        "Name": "South Africa"
    },
    {
        "Id": 162,
        "Name": "South Korea"
    },
    {
        "Id": 163,
        "Name": "South Sudan"
    },
    {
        "Id": 164,
        "Name": "Spain"
    },
    {
        "Id": 165,
        "Name": "Sri Lanka"
    },
    {
        "Id": 166,
        "Name": "Sudan"
    },
    {
        "Id": 167,
        "Name": "Suriname"
    },
    {
        "Id": 168,
        "Name": "Sweden"
    },
    {
        "Id": 169,
        "Name": "Switzerland"
    },
    {
        "Id": 170,
        "Name": "Syria"
    },
    {
        "Id": 171,
        "Name": "Taiwan"
    },
    {
        "Id": 172,
        "Name": "Tajikistan"
    },
    {
        "Id": 173,
        "Name": "Tanzania"
    },
    {
        "Id": 174,
        "Name": "Thailand"
    },
    {
        "Id": 175,
        "Name": "Timor-Leste"
    },
    {
        "Id": 176,
        "Name": "Togo"
    },
    {
        "Id": 177,
        "Name": "Tonga"
    },
    {
        "Id": 178,
        "Name": "Trinidad and Tobago"
    },
    {
        "Id": 179,
        "Name": "Tunisia"
    },
    {
        "Id": 180,
        "Name": "Turkey"
    },
    {
        "Id": 181,
        "Name": "Turkmenistan"
    },
    {
        "Id": 182,
        "Name": "Tuvalu"
    },
    {
        "Id": 183,
        "Name": "Uganda"
    },
    {
        "Id": 184,
        "Name": "Ukraine"
    },
    {
        "Id": 185,
        "Name": "United Arab Emirates (UAE)"
    },
    {
        "Id": 186,
        "Name": "United Kingdom (UK)"
    },
    {
        "Id": 187,
        "Name": "United States of America (USA)"
    },
    {
        "Id": 188,
        "Name": "Uruguay"
    },
    {
        "Id": 189,
        "Name": "Uzbekistan"
    },
    {
        "Id": 190,
        "Name": "Vanuatu"
    },
    {
        "Id": 191,
        "Name": "Vatican City (Holy See)"
    },
    {
        "Id": 192,
        "Name": "Venezuela"
    },
    {
        "Id": 193,
        "Name": "Vietnam"
    },
    {
        "Id": 194,
        "Name": "Yemen"
    },
    {
        "Id": 195,
        "Name": "Zambia"
    },
    {
        "Id": 196,
        "Name": "Zimbabwe"
    }
]

export const GET_RESIDENCE_TYPES = [
    {
        "Id": 0,
        "Name": "Unknown"
    },
    {
        "Id": 1,
        "Name": "Self Owned"
    },
    {
        "Id": 2,
        "Name": "Parents"
    },
    {
        "Id": 3,
        "Name": "Rental or Lease"
    },
    {
        "Id": 4,
        "Name": "Friends or Relatives"
    }
]

export const GET_QUESTION_TYPES = [
    {
        "Id": "d25e9413-8faf-49b7-9847-31649ee0e014",
        "Question": "How did you hear about us",
        "QuestionType": 0,
        "QuestionCategoryId": 1,
        "QuestionCategoryName": "Business Information",
        "VendorTypeQuestionOptions": []
    },
    {
        "Id": "925a2c9d-f442-440f-8a79-9ff0eca7a5c3",
        "Question": "what do you sell",
        "QuestionType": 0,
        "QuestionCategoryId": 0,
        "QuestionCategoryName": "Other Information",
        "VendorTypeQuestionOptions": []
    },
    {
        "Id": "37e3c13e-c17d-4747-bffa-31800a4a3e57",
        "Question": "Where is your office",
        "QuestionType": 1,
        "QuestionCategoryId": 0,
        "QuestionCategoryName": "Other Information",
        "VendorTypeQuestionOptions": [
            {
                "Id": "1e1d4594-148b-4a64-958c-313e8c44ca02",
                "Option": "Yes",
                "OrderBy": 0
            },
            {
                "Id": "2be5f503-a76b-40f9-91fb-97c40848a999",
                "Option": "No",
                "OrderBy": 1
            }
        ]
    },
    {
        "Id": "40171739-bf3b-466a-834d-ac6ab390b2c6",
        "Question": "When was your company last audited?",
        "QuestionType": 0,
        "QuestionCategoryId": 0,
        "QuestionCategoryName": "Other Information",
        "VendorTypeQuestionOptions": []
    },
    {
        "Id": "c5ae716b-796b-40e1-a7a9-15fa19a2d0e3",
        "Question": "Is your company product/system registered to any quality management system or product standard?",
        "QuestionType": 1,
        "QuestionCategoryId": 0,
        "QuestionCategoryName": "Other Information",
        "VendorTypeQuestionOptions": [
            {
                "Id": "a7301293-108e-4c52-8fbb-25ded46b8c29",
                "Option": "yes",
                "OrderBy": 0
            },
            {
                "Id": "a933ecfe-1417-4b08-bd34-63457229c156",
                "Option": "no",
                "OrderBy": 1
            }
        ]
    }
]

export const GET_COMPANY_TYPES = [
    {
        "Id": 9,
        "Name": "Start-Up"
    },
    {
        "Id": 8,
        "Name": "Small-Medium Business"
    },
    {
        "Id": 7,
        "Name": "Self Employed"
    },
    {
        "Id": 6,
        "Name": "Non-Profit"
    },
    {
        "Id": 5,
        "Name": "Government-State & Local"
    },
    {
        "Id": 4,
        "Name": "Government-Federal"
    },
    {
        "Id": 3,
        "Name": "Government/Public sector"
    },
    {
        "Id": 2,
        "Name": "Enterprise"
    },
    {
        "Id": 1,
        "Name": "Education"
    }
]

export const GET_VENDOR_DOCUMENT_COMMENTS = [{
    "DocumentUrl": "rocket-1621081079541.png",
    "Comment": "OK noted... Here's the requested document for your perusal",
    "CreateDatte": "2021-05-17T01:21:15.983911",
    "UserId": null,
    "AdminName": null,
    "IsVendorComment": true
}, {
    "DocumentUrl": null,
    "Comment": "We want a full company profile not just your company logo",
    "CreateDatte": "2021-05-17T01:13:42.152791",
    "UserId": 3,
    "AdminName": "Test User1",
    "IsVendorComment": false
}]

export const GET_TOTAL_PENDING_VENDORS = 906;

export const GET_RECENT_VENDOR_DOC_STATUSES = {
    "TotalCount": 5,
    "CurrentPage": 0,
    "ExpectedPageSize": 5,
    "Results": [{
        "Vendor": "Kadigun Enterprises",
        "ApprovedDocumentCount": 0,
        "PendingDocumentCount": 1,
        "RejectedDocumentCount": 0,
        "TotalDocumentCount": 1,
        "ApprovedDocumentPercent": 0,
        "PendingDocumentPercent": 100,
        "RejectedDocumentPercent": 0
    }, {
        "Vendor": "ugoajalla",
        "ApprovedDocumentCount": 1,
        "PendingDocumentCount": 0,
        "RejectedDocumentCount": 0,
        "TotalDocumentCount": 1,
        "ApprovedDocumentPercent": 100,
        "PendingDocumentPercent": 0,
        "RejectedDocumentPercent": 0
    }, {
        "Vendor": "Igunle Tech 2",
        "ApprovedDocumentCount": 0,
        "PendingDocumentCount": 0,
        "RejectedDocumentCount": 0,
        "TotalDocumentCount": 0,
        "ApprovedDocumentPercent": 0,
        "PendingDocumentPercent": 0,
        "RejectedDocumentPercent": 0
    }, {
        "Vendor": "Testaroo Edit",
        "ApprovedDocumentCount": 0,
        "PendingDocumentCount": 0,
        "RejectedDocumentCount": 0,
        "TotalDocumentCount": 0,
        "ApprovedDocumentPercent": 0,
        "PendingDocumentPercent": 0,
        "RejectedDocumentPercent": 0
    }, {
        "Vendor": "Business Name Sample",
        "ApprovedDocumentCount": 0,
        "PendingDocumentCount": 0,
        "RejectedDocumentCount": 0,
        "TotalDocumentCount": 0,
        "ApprovedDocumentPercent": 0,
        "PendingDocumentPercent": 0,
        "RejectedDocumentPercent": 0
    }]
}

export const GET_TOTAL_VENDORS_PER_CATEGORY = [
    {
        "Category": "Technology",
        "Count": 12
    },
    {
        "Category": "Construction",
        "Count": 1
    },
    {
        "Category": "Automobiles",
        "Count": 1
    },
    {
        "Category": "Fabric",
        "Count": 1
    },
    {
        "Category": "New test Category",
        "Count": 0
    },
    {
        "Category": "Second Test Category",
        "Count": 0
    },
    {
        "Category": "Side Category",
        "Count": 1
    },
    {
        "Category": "string",
        "Count": 0
    },
    {
        "Category": "General Business",
        "Count": 1
    }
]

export const DOWNLOAD_VENDORS = [{
    "Id": "85948076-9977-4bef-980a-bfed534316e3",
    "ContactSurname": "Ugochukwu",
    "ContactFirstname": "Ajalla",
    "ContactEmailAddress": "ugoprojectz@gmail.com",
    "ContactPhoneNumber": "+2348068440754",
    "VendorName": "jallas",
    "VendorStatus": 0,
    "VendorStatusName": "Pending",
    "CategoryName": "Technology",
    "StatusReason": null,
    "InitiatingCompanyId": 19
}, {
    "Id": "0336487c-fdbd-4d3f-a5f9-8a9ba3ab98a5",
    "ContactSurname": "Lastname",
    "ContactFirstname": "Firstname",
    "ContactEmailAddress": "fl@test.com",
    "ContactPhoneNumber": "2348023123451",
    "VendorName": "Beans Provider",
    "VendorStatus": 0,
    "VendorStatusName": "Pending",
    "CategoryName": "Technology",
    "StatusReason": null,
    "InitiatingCompanyId": 19
}, {
    "Id": "1963b89f-fc45-48c5-ae8e-ab97273146a0",
    "ContactSurname": "Ghandi",
    "ContactFirstname": "Solomon",
    "ContactEmailAddress": "sghandi@sharklasers.com",
    "ContactPhoneNumber": "2348032123451",
    "VendorName": "SKG Technologies",
    "VendorStatus": 5,
    "VendorStatusName": "Awaiting Approval",
    "CategoryName": "Technology",
    "StatusReason": null,
    "InitiatingCompanyId": 19
}, {
    "Id": "92f50a76-5c57-4c28-8b65-1f5bbcb1ebfc",
    "ContactSurname": "Test",
    "ContactFirstname": "Vendor",
    "ContactEmailAddress": "vendortester@test.com",
    "ContactPhoneNumber": "2346767667839",
    "VendorName": "Testing Vendor Creation",
    "VendorStatus": 0,
    "VendorStatusName": "Pending",
    "CategoryName": "Automobiles",
    "StatusReason": null,
    "InitiatingCompanyId": 0
}, {
    "Id": "7e973251-7571-4880-a5d4-d40f40decc20",
    "ContactSurname": "Ugochukwu",
    "ContactFirstname": "Ajalla",
    "ContactEmailAddress": "ajallau@yahoo.com",
    "ContactPhoneNumber": "08068440754",
    "VendorName": "OHMSFLEX NIG LTD",
    "VendorStatus": 4,
    "VendorStatusName": "Cancelled",
    "CategoryName": "Technology",
    "StatusReason": "testing",
    "InitiatingCompanyId": 0
}, {
    "Id": "a9e5a652-d76c-43cd-bb96-2e69ad768d14",
    "ContactSurname": "Okeowo",
    "ContactFirstname": "Aderemi",
    "ContactEmailAddress": "okeremi@sharklasers.com",
    "ContactPhoneNumber": "08032123451",
    "VendorName": "Remitrix Technologies",
    "VendorStatus": 1,
    "VendorStatusName": "Approved",
    "CategoryName": "Technology",
    "StatusReason": null,
    "InitiatingCompanyId": 19
}, {
    "Id": "c0b07347-9377-4289-987d-7d4519d4a884",
    "ContactSurname": "damilola",
    "ContactFirstname": "adekagun",
    "ContactEmailAddress": "damiadek2009@gmail.com",
    "ContactPhoneNumber": "+2345676786578",
    "VendorName": "adekagun damilola",
    "VendorStatus": 2,
    "VendorStatusName": "Rejected",
    "CategoryName": "Technology",
    "StatusReason": "Background check came back with some worrisome details. Please refer to Lega & Risk if you need more information",
    "InitiatingCompanyId": 0
}, {
    "Id": "43b9e979-61a1-4bf7-8c10-a2ac65c2ac3e",
    "ContactSurname": "Clerk",
    "ContactFirstname": "Lambert",
    "ContactEmailAddress": "ckdaf2000@yahoo.co.uk",
    "ContactPhoneNumber": "+2348032123451",
    "VendorName": "Lambert Clerk",
    "VendorStatus": 1,
    "VendorStatusName": "Approved",
    "CategoryName": "Technology",
    "StatusReason": null,
    "InitiatingCompanyId": 19
}, {
    "Id": "0e3f9a4c-ab93-4cf3-8de1-19ac3b39aef9",
    "ContactSurname": "Sample",
    "ContactFirstname": "Man",
    "ContactEmailAddress": "sample@man.com",
    "ContactPhoneNumber": "2348032123451",
    "VendorName": "Sample Vendor",
    "VendorStatus": 1,
    "VendorStatusName": "Approved",
    "CategoryName": "Technology",
    "StatusReason": "Test cancel",
    "InitiatingCompanyId": 19
}]

export const GET_QUESTION_CATEGORIES = [
    {
        "Id": 0,
        "Name": "Other Information"
    },
    {
        "Id": 1,
        "Name": "Business Information"
    },
    {
        "Id": 2,
        "Name": "Passport Information"
    },
    {
        "Id": 3,
        "Name": "Director Information"
    },
    {
        "Id": 4,
        "Name": "Executive Director Information"
    }
]

export const GET_BANKS = [
    {
        "Id": 0,
        "Name": "Access Bank Plc"
    },
    {
        "Id": 1,
        "Name": "Fidelity Bank Plc"
    },
    {
        "Id": 2,
        "Name": "First City Monument Bank Limited"
    },
    {
        "Id": 3,
        "Name": "First Bank of Nigeria Limited"
    },
    {
        "Id": 4,
        "Name": "Guaranty Trust Bank Plc(GTBank)"
    },
    {
        "Id": 5,
        "Name": "Union Bank of Nigeria Plc"
    },
    {
        "Id": 6,
        "Name": "United Bank for Africa Plc (UBA)"
    },
    {
        "Id": 7,
        "Name": "Zenith Bank Plc"
    },
    {
        "Id": 8,
        "Name": "Citibank Nigeria Limited"
    },
    {
        "Id": 9,
        "Name": "Ecobank Nigeria"
    },
    {
        "Id": 10,
        "Name": "Heritage Bank Plc"
    },
    {
        "Id": 11,
        "Name": "Keystone Bank Limited"
    },
    {
        "Id": 12,
        "Name": "Polaris Bank Limited"
    },
    {
        "Id": 13,
        "Name": "Stanbic IBTC Bank Plc"
    },
    {
        "Id": 14,
        "Name": "Standard Chartered"
    },
    {
        "Id": 15,
        "Name": "Sterling Bank Plc"
    },
    {
        "Id": 16,
        "Name": "Titan Trust Bank Limited"
    },
    {
        "Id": 17,
        "Name": "Unity Bank Plc"
    },
    {
        "Id": 18,
        "Name": "Wema Bank Plc"
    },
    {
        "Id": 19,
        "Name": "Globus Bank Limited"
    },
    {
        "Id": 20,
        "Name": "SunTrust Bank Nigeria Limited"
    },
    {
        "Id": 21,
        "Name": "Providus Bank Limited"
    },
    {
        "Id": 22,
        "Name": "Jaiz Bank Plc"
    },
    {
        "Id": 23,
        "Name": "TAJBank Limited"
    },
    {
        "Id": 24,
        "Name": "Other Bank"
    }
]

export const GET_TIN_CATEGORIES = [
    {
        "Id": 1,
        "Name": "State"
    },
    {
        "Id": 2,
        "Name": "Federal"
    }
]

export const GET_APPROVAL_SETTINGS = [
    {
        "Id": 3,
        "RoleId": 0,
        "RoleName": null,
        "OrderBy": 2,
        "ApprovingUserId": 952,
        "ApprovingUserName": "TEST USER2"
    },
    {
        "Id": 2,
        "RoleId": 0,
        "RoleName": null,
        "OrderBy": 1,
        "ApprovingUserId": 3,
        "ApprovingUserName": "Test User1"
    }
]